module.exports = __webpack_public_path__ + "assets/images/project/meta-data-centre.jpg?v=b167b7fa";